import styled from 'styled-components';
import { getSafeAreaValue } from '../../../../../styled/theme/helpers/getSafeAreaValue';
import { Breakpoints } from '../../../../../styled/constants';
import { PhoneBottomWrapper } from '../../../../StickyPhoneButton/styled';

export const Content = styled.div`
  padding: 20px 15px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 20)};

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    position: relative;
    padding: 40px;
    display: flex;
    gap: 36px;
    width: 100%;
    height: 100%;
  }
`;

export const PhoneButton = styled.div`
  ${PhoneBottomWrapper} {
    position: static;
    width: 100%;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;
